import { IInputStatus } from '../../../../interface/progress.interface'

const arr = ['geo_province', 'geo_zip', 'geo_city']

export const tooltipHandler = (store: any) => {
  console.log('tooltipHandler', store)
  if (store.isTooltip) {
    console.log('tooltipHandler true')
    store.values.geo_zip = ''
    store.rootStore.ProgressStore.changeStatus(
      'geo_zip',
      IInputStatus.none,
      store.currentStep
    )
    store.values.geo_province = ''
    store.rootStore.ProgressStore.changeStatus(
      'geo_province',
      IInputStatus.none,
      store.currentStep
    )
    store.values.geo_city = ''
    store.rootStore.ProgressStore.changeStatus(
      'geo_city',
      IInputStatus.none,
      store.currentStep
    )
    store.isTooltip = false
    console.log(store.isTooltip)
    console.log({ ...store.values })
  }
}
export const closeTooltipStep = (store: any) => {
  store.isTooltip = false
}

export const checkTooltipHandler = (
  name: string,
  store: any
) => {
  console.log(name, arr.indexOf(name) !== -1)
  if (store.isTooltip && arr.indexOf(name) !== -1) {
    store.isTooltip = false
    // tooltipHandler(store)
  }
}

